import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Editor } from '@tinymce/tinymce-react';
// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from '../Miscelania/Loading';
import Overlay from '../Miscelania/Overlay';
// Helpers de formulário
import Topo from '../Layout/Topo';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import RequestApi from '../Miscelania/RequestApi';


class ConfiguracoesMoodleEdit extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: 1,
      default_student_role_id: '',
      default_instructor_role_id: '',
      token_production: '',
      url_production: '',
      token_development: '',
      url_development: '',
    };
    //bind geral
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }

  // Handlers de form
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData(e) {
    var url = config.get('api') + '/config/moodle/1';
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/categorias');
        if (responseJson.status === 'success') {
          self.setState({
              id: responseJson.data.id,
              default_student_role_id: responseJson.data.default_student_role_id,
              default_instructor_role_id: responseJson.data.default_instructor_role_id,
              token_production: responseJson.data.token_production,
              url_production: responseJson.data.url_production,
              token_development: responseJson.data.token_development,
              url_development: responseJson.data.url_development,
            });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
        id: this.state.id,
        default_student_role_id: this.state.default_student_role_id,
        default_instructor_role_id: this.state.default_instructor_role_id,
        token_production: this.state.token_production,
        url_production: this.state.url_production,
        token_development: this.state.token_development,
        url_development: this.state.url_development,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/config/moodle/1', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title"><i className="fa fa-fw fa-cog"></i> Configurações da Integração Moodle</h3>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                <label>ID Padrão do Papel de Aluno:</label>
                <input type="number" value={this.state.default_student_role_id} name="default_student_role_id" className="form-control" onChange={this.handleChange.bind(this, 'default_student_role_id')} placeholder="" />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                <label>ID Padrão do Papel de Tutor:</label>
                <input type="number" value={this.state.default_instructor_role_id} name="default_instructor_role_id" className="form-control" onChange={this.handleChange.bind(this, 'default_instructor_role_id')} placeholder="" />
                </div>
            </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <div className="form-group">
              <label>Token - Produção:</label>
              <input type="text" value={this.state.token_production} name="token_production" className="form-control" onChange={this.handleChange.bind(this, 'token_production')} placeholder="" />
              </div>
          </div>
          <div className="col-md-6">
              <div className="form-group">
              <label>URL - Produção:</label>
              <input type="text" value={this.state.url_production} name="url_production" className="form-control" onChange={this.handleChange.bind(this, 'url_production')} placeholder="" />
              </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <div className="form-group">
              <label>Token - Homologação:</label>
              <input type="text" value={this.state.token_development} name="token_development" className="form-control" onChange={this.handleChange.bind(this, 'token_development')} placeholder="" />
              </div>
          </div>
          <div className="col-md-6">
              <div className="form-group">
              <label>URL - Homologação:</label>
              <input type="text" value={this.state.url_development} name="url_development" className="form-control" onChange={this.handleChange.bind(this, 'url_development')} placeholder="" />
              </div>
          </div>
        </div>
        <div className="row">
            <div className="form-group">
            <button className="btn btn-primary btn-block btn-inline" type="submit"><i className="fa fa-fw fa-save"></i> Salvar Configurações</button>
            </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ConfiguracoesMoodleEdit;



// WEBPACK FOOTER //
// ./src/Components/Configuracoes/ConfiguracoesMoodleEdit.js